/* eslint-disable jsx-a11y/alt-text */
import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDiscord } from '@fortawesome/free-brands-svg-icons'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export const DiscordLink: React.FC = () => {
  return (
    <a href='https://discord.gg/5s2rhp8qBq' target='_blank' rel='noreferrer'>
      Discord <FontAwesomeIcon size='xs' icon={faDiscord as IconDefinition} />
    </a>
  )
}

export default DiscordLink
